import { Typography, IconButton as UiIconButton, styled, styledForMobile, theme } from "@l2r-front/l2r-ui"

export const Container = styledForMobile("div")(({ theme, isMobile }) => ({
    height: "100%",
    padding: isMobile ? theme.spacing(0, 4, 4, 4) : theme.spacing(0, 8, 8, 8),
}))

export const TitleSideComponentWrapper = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
})

export const IconButton = styled(UiIconButton)(() => ({
    marginLeft: "auto",
}))

export const Wrapper = styled("div")({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2),
})

export const Label = styled(Typography)(({ theme }) => ({
    color: theme.palette["action/disabled"].main,
}))

export const Logo = styled("img")(() => ({
    height: 40,
}))

export const ContentWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
}))